import {
  AppLoaderEnd,
  AppLoaderStart,
  ParkingLoader,
  useConfigUIV2,
} from '@gimlite/ui-v2';
import { createRoot } from 'react-dom/client';
import { CustomRouter } from './CustomRouter';
import config from './config';

const { ENV, VERSION_FRONT, BFF_HOST, BFF_WS_HOST } = config;

const defaultTheme = 'light';

const App = () => {
  const {
    ConfigDialog,
    ConfigGQL,
    ConfigI18N,
    ConfigNotification,
    ConfigSSO,
    ConfigApp,
    ConfigMenu,
    ConfigTheme,
    ConfigRoot,
  } = useConfigUIV2();

  return (
    <ConfigRoot>
      <AppLoaderStart
        item={ParkingLoader()}
        type="loader"
        defaultTheme={defaultTheme}
        color={{
          dark: '#5dbed2',
          light: '#232653',
        }}
      >
        <ConfigApp
          debug={false}
          version={{
            env: config?.ENV,
            front: VERSION_FRONT,
          }}
          favicon={
            'https://cellar-c2.services.clever-cloud.com/yoonite-resources/default/iem.svg'
          }
        >
          <ConfigGQL
            uri={BFF_HOST}
            headers={{
              'x-access-token': config.BFF_TOKEN,
            }}
          >
            <ConfigSSO
              mode={{ type: 'children', parentUrl: config.SSO_PARENT_URL }}
              instance={{
                url: config.SSO_URL,
                realm: config.SSO_REALM,
                clientId: config.SSO_CLIENT_ID,
              }}
            >
              <ConfigI18N>
                <ConfigDialog>
                  <ConfigMenu>
                    <ConfigNotification>
                      <ConfigTheme defaultTheme={defaultTheme}>
                        <AppLoaderEnd>
                          <CustomRouter />
                        </AppLoaderEnd>
                      </ConfigTheme>
                    </ConfigNotification>
                  </ConfigMenu>
                </ConfigDialog>
              </ConfigI18N>
            </ConfigSSO>
          </ConfigGQL>
        </ConfigApp>
      </AppLoaderStart>
    </ConfigRoot>
  );
};

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);
